import type { ILine } from './line';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IPolyline extends ILine {}
